import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import React, { useMemo } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import DOMPurify from 'dompurify';

interface Props {
  title: string;
  content: string;
  dividerTitle?: boolean;
  disableTextSelection?: boolean;
  isSummary?: boolean;
}

export default function MultiLineTextElement({
  title,
  content,
  dividerTitle = false,
  disableTextSelection = false,
  isSummary = false,
}: Props) {
  const html = useMemo(() => {
    if (content) return content.replaceAll('\n', '<br />');
    return '';
  }, [content]);

  const lightTheme = createTheme({
    palette: {
      mode: 'light',
    },
  });

  const contentElement = (
    <Box height="100%" display="flex" flexDirection="column">
      {dividerTitle && (
        <Box pt="5px">
          <Divider>{title}</Divider>
        </Box>
      )}
      {!dividerTitle && (
        <Typography
          variant="h6"
          component="div"
          fontWeight={600}
          sx={disableTextSelection ? undefined : { userSelect: 'text' }}
        >
          {title}
        </Typography>
      )}
      {content && content.length > 0 && (
        <Box
          overflow="auto"
          p="10px"
          flexGrow={1}
          sx={{
            background: isSummary ? 'white' : undefined,
            color: isSummary ? 'black' : undefined,
          }}
        >
          <Typography
            variant="body2"
            component="div"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
            sx={disableTextSelection ? undefined : { userSelect: 'text' }}
          />
        </Box>
      )}
    </Box>
  );

  return isSummary ? (
    <ThemeProvider theme={lightTheme}>{contentElement}</ThemeProvider>
  ) : (
    contentElement
  );
}
